import {Injectable} from '@angular/core';

@Injectable({
              providedIn: 'root'
            })
export class DomainUrlService {

  constructor() {
    this.protocol = this.getProtocol() + '//';

    const domain = window.location.host;
    const indexDevSeparator = domain.indexOf(DomainUrlService.DEV_SEPARATOR);
    const indexProdSeparator = domain.indexOf(DomainUrlService.PROD_SEPARATOR);
    if (indexDevSeparator !== -1) {
      this.staticDomain = domain.substring(indexDevSeparator);
      this.jwtDomain = this.staticDomain.substring(this.staticDomain.indexOf('.') + 1);
    } else {
      this.staticDomain = domain.substring(indexProdSeparator);
      this.jwtDomain = domain.substring(indexProdSeparator + 1);
    }
  }

  private static readonly PROD_DOMAIN = 'com';

  private static DEV_SEPARATOR = '---';
  private static PROD_SEPARATOR = '.';

  private staticDomain: string;
  private jwtDomain: string;
  private protocol: string;

  private static isProdDomain(domain: string): boolean {
    return domain.endsWith(DomainUrlService.PROD_DOMAIN);
  }

  public isProdDomain(): boolean {
    return this.staticDomain.endsWith(DomainUrlService.PROD_DOMAIN);
  }

  public getLoginUrl(): string {
    const loginAppId = DomainUrlService.isProdDomain(this.staticDomain) ? 'login' : 'optim-login';
    return this.getAppDomain(loginAppId);
  }

  public getRepositoryApiUrl(): string {
    return this.getAppDomain('repository') + '/api';
  }

  public getOptimPortalBackUrl(): string {
    return this.getAppDomain('optim');
  }

  public getOptimAccountUrl(): string {
    return this.getAppDomain('optim-account');
  }

  public getOptimPortalBackApiUrl(): string {
    return this.getOptimPortalBackUrl() + '/api';
  }

  public getDashboardUrl(): string {
    return this.getAppDomain('optim');
  }

  public getPublicationUrl(): string {
    return this.getAppDomain('optim-publication');
  }

  public getInsitoUrl(): string {
    return this.getAppDomain('insito');
  }

  public getAllianceUrl(): string {
    return this.getAppDomain('alliance');
  }

  public getInviseoUrl(): string {
    return this.getAppDomain('inviseo');
  }

  public getFundingtenderUrl(): string {
    return this.getAppDomain('funding-tender');
  }

  public getBankProposalUrl(): string {
    return this.getAppDomain('bank-proposal-dashboard');
  }

  public getProtocol(): string {
    return window.location.protocol;
  }

  private getAppDomain(appId: string): string {
    return this.protocol + appId + this.staticDomain;
  }
}
